module.exports = __webpack_public_path__ + "static/img/son7.f5aa81bd.png";